// client/src/pbSkillsSolar/PbSkillsSolar.tsx
import React from "react";
import App from "./main/App";

export function PbSkillsSolar() {
  return <App />;
}